import { graphql, useLazyLoadQuery } from "react-relay";
import { useTranslation } from "@i18n/hooks";

import { type instructorsScreen_InstructorsQuery } from "@relay/instructorsScreen_InstructorsQuery.graphql";
import { BaseScreen } from "../../components/base-screen";
import { NoAccess } from "../../components/no-access";
import { InstructorsTable } from "../../features/instructors/instructors-table/instructors-table.component";
import { useHasPermissions } from "../../hooks/use-has-permissions";

export const InstructorsScreen = () => {
	const { t } = useTranslation("common");

	const data = useLazyLoadQuery<instructorsScreen_InstructorsQuery>(
		graphql`
			query instructorsScreen_InstructorsQuery {
				...instructorsTable_InstructorsListFragment
			}
		`,
		{},
		{ fetchPolicy: "network-only" },
	);

	const canRead = useHasPermissions(["UserInAccountPermission_Instructors_ReadInstructors"]);

	if (!canRead) return <NoAccess />;

	return (
		<BaseScreen title={t("instructor.screenTitle")}>
			<InstructorsTable instructorsFragmentRef={data} />
		</BaseScreen>
	);
};
